/* ============================================================
   Warenkorb — Minus bei Menge 1 entfernt die Position.

   Dawn lässt die Menge nicht unter das Minimum der Variante fallen: Der Minus-Knopf wird
   bei 1 als „disabled" markiert, und wer trotzdem einen kleineren Wert einträgt, bekommt
   die Meldung „Dieser Artikel hat ein Minimum von 1". Zum Entfernen muss man den
   Mülleimer treffen.

   Hier ist das zusammengelegt: Minus bei 1 bedeutet löschen. Es gibt damit zwei Wege zum
   selben Ziel, und die Warnung entfällt, weil der Fall gar nicht mehr eintritt.

   Umgesetzt wird das durch einen Klick auf den vorhandenen Entfernen-Knopf derselben
   Zeile — bewusst NICHT durch Setzen der Menge auf 0: Ein Wert unter dem Minimum löst
   genau die Prüfung aus, die wir loswerden wollen.

   Der Verarbeiter läuft in der Capture-Phase und stoppt das Ereignis, damit Dawns eigener
   Verarbeiter am Mengenfeld gar nicht erst anspringt.
   ============================================================ */
(function () {
  'use strict';

  document.addEventListener(
    'click',
    function (event) {
      var minus = event.target.closest('.cart-item .quantity__button[name="minus"]');
      if (!minus) return;

      var wrapper = minus.closest('quantity-input');
      var input = wrapper ? wrapper.querySelector('.quantity__input') : null;
      if (!input) return;

      // WICHTIG: data-min, nicht das HTML-Attribut min.
      //
      // Dawn setzt am Mengenfeld beides — min="0" und data-min="1". Die 0 steht dort, damit
      // sich eine Position durch Eintippen einer 0 entfernen lässt; die tatsächliche
      // Mindestmenge der Variante steht in data-min. Wer min ausliest, bekommt also 0,
      // hält Menge 1 für „über dem Minimum" und lässt Dawn auf 0 herunterzählen — und
      // genau dort schlägt dessen Prüfung gegen data-min an und zeigt die Warnung.
      var min = parseInt(input.dataset.min, 10);
      if (isNaN(min)) min = parseInt(input.min, 10);
      if (isNaN(min) || min < 1) min = 1;

      var value = parseInt(input.value, 10);
      if (isNaN(value)) return;

      // Oberhalb der Mindestmenge normal weiterzählen lassen.
      if (value > min) return;

      event.preventDefault();
      event.stopPropagation();

      var row = minus.closest('.cart-item');
      var remove = row ? row.querySelector('cart-remove-button') : null;
      if (!remove) return;

      // Der Klick muss den Knopf IM Element treffen: CartRemoveButton hört auf Klicks,
      // die von innen zu ihm hochsteigen.
      var inner = remove.querySelector('a, button');
      (inner || remove).click();
    },
    true
  );
})();
